import { FeedbackFilterDetails } from "../types/feedbackTypes";
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE, DESC_ORDER } from "@duosoftbg/nacid-components";

export const feedbackFilterInitialValues: FeedbackFilterDetails = {
  name: "",
  createdDateFrom: undefined,
  createdDateTo: undefined,
  page: DEFAULT_PAGE,
  pageSize: DEFAULT_PAGE_SIZE,
  order: DESC_ORDER,
  orderBy: "createdDate",
};
